// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CaretRight: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 14">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="m1.735 13.703 5.99-6.046A.927.927 0 0 0 8 7a.927.927 0 0 0-.275-.656L1.735.298A1.043 1.043 0 0 0 .315.261a.92.92 0 0 0-.04 1.35L5.65 7 .276 12.39a.92.92 0 0 0 .039 1.35c.399.36 1.035.343 1.42-.038Z"
            />
        </svg>
    );
};

export default React.memo(CaretRight);
